import React from 'react';
import { determineAppType } from '../utils/appDetection';

const TestRoute = () => {
  const appType = determineAppType();
  
  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f0f0', margin: '20px' }}>
      <h1>Test Route Working!</h1>
      <p>This is a simple test to check if routing is working.</p>
      <p>Current URL: {window.location.href}</p>
      <p>Current pathname: {window.location.pathname}</p>
      <p><strong>App Type Detected: {appType}</strong></p>
      <p>Hostname: {window.location.hostname}</p>
      <p>Port: {window.location.port}</p>
    </div>
  );
};

export default TestRoute;